const getters = {
  getSubscriptionPeriodEnd: (state, getters, rootState) => {
    const p = rootState.payment?.currentPlan
    if (!p) return null
    return p.currentPeriodEnd
  },
  getSubscriptionDaysUntilEnd: (state, getters) => {
    const end = getters.getSubscriptionPeriodEnd
    if (!end) return null
    const diff = new Date(end) - new Date()
    return Math.ceil(diff / (1000 * 60 * 60 * 24))
  },
  getSubscriptionPeriodEnded: (state, getters) => {
    const daysUntilEnd = getters.getSubscriptionDaysUntilEnd
    if (daysUntilEnd === null) return false
    return daysUntilEnd <= 0
  },
  hasBillingIssue: (state, getters, rootState) => {
    return rootState.payment?.currentPlan?.status === 'past_due'
  },
  getSubscriptionBannerState: (state, getters, rootState) => {
    if (getters.hasBillingIssue) return 'ended'
    const days = getters.getSubscriptionDaysUntilEnd
    const p = rootState.payment?.currentPlan
    if (days && days <= 0 || p && p.hadSubscription) return 'ended'
    if (days && days <= 3 && p?.status === 'cancel_pending') return 'expiring'
    return null
  },
}

export default getters
